import React, { FC, useCallback, useMemo, useState } from 'react';
import { isTextElementEmpty, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Button, Card, Divider, Drawer } from 'antd';
import { AddressDisplay } from '../address_display/AddressDisplay';
import Mapbox from '../mapbox/Mapbox';
import { CloseOutlined } from '@ant-design/icons';
import { Content } from 'antd/lib/layout/layout';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';
import { connect } from 'react-redux';
import ContractorLocationPageDisplay from '../contractor_locations/ContractorLocationPageDisplay';

const ContractorLocationCardDisplay: FC<any> = ({
	contractorLocation,
	mapHeight = 240,
	mapWidth = '100%',
	currentUser,
	onViewLocationPage,
}): React.ReactElement => {
	const [locationDrawerVisible, setLocationDrawerVisible] = useState(false);

	const _handleLocationDrawerOpen = () => setLocationDrawerVisible(true);

	const _handleLocationDrawerClose = () => setLocationDrawerVisible(false);

	const photoUris = useMemo(
		() =>
			nullSafeGetOrElse('images', contractorLocation, []).map((locImg) => {
				const [imgFileId, imgFileName] = locImg.split('/');
				return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 'auto');
			}),
		[contractorLocation]
	);

	return (
		<div>
			<Drawer
				width={1000}
				placement="right"
				closable={false}
				onClose={_handleLocationDrawerClose}
				visible={locationDrawerVisible}
				bodyStyle={{ paddingBottom: 0 }}
			>
				<div
					//Header
					className={'absolute right-0 top-0 z-40 flex flex-row'}
				>
					<Button onClick={_handleLocationDrawerClose} type={'text'} style={{ padding: '8px' }}>
						<CloseOutlined style={{ fontSize: '24px', color: 'white' }} />
					</Button>
				</div>
				<Content className="supplierLocationPageDisplay">
					<div
						className={
							(photoUris.length && photoUris.length > 0) || !contractorLocation.isActive
								? 'imageLayout'
								: 'noImageLayout'
						}
					>
						{!contractorLocation.isActive ? (
							<div className="inactiveBanner">
								<div className="inactiveLabel">Inactive</div>
							</div>
						) : null}
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`layout ${
								(photoUris.length && photoUris.length > 0) || !contractorLocation.isActive
									? 'imageLayout__gradientOverlay'
									: 'noImageLayout__gradientOverlay'
							}`}
						>
							<div className="textContainer">
								<div className="leftItems">
									<h4 className="locationPageDisplay__title">{contractorLocation.name}</h4>
								</div>
								<div className="rightItems">
									{nullSafeGet('facility.supplierCompany.privateBuyerCompanyId', currentUser) ? (
										<Button style={{ color: 'white' }} type="ghost" onClick={onViewLocationPage}>
											View Location Page
										</Button>
									) : null}
								</div>
							</div>
						</div>
					</div>
					<ContractorLocationPageDisplay record={contractorLocation} locationsFetching={false} />
				</Content>
			</Drawer>
			<Card
				className="materialCard"
				bodyStyle={{ padding: 0 }}
				hoverable={true}
				onClick={_handleLocationDrawerOpen}
			>
				<div
					style={{
						height: mapHeight,
						width: mapWidth,
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
					}}
				>
					<Mapbox
						longitude={nullSafeGet('longitude', contractorLocation)}
						latitude={nullSafeGet('latitude', contractorLocation)}
						baseLayerStyle="light"
						zoomLevel={7}
					/>
				</div>
				<div style={{ height: 240, position: 'relative' }} />
				<div className="materialCard__body">
					<div className="materialCard__primaryTitle">
						<div className="materialCard__title">{nullSafeGet('name', contractorLocation)}</div>
						<div className="materialCard__subtitle">
							#{nullSafeGet('storeId', contractorLocation)}
						</div>
					</div>
					<AddressDisplay
						hidePostcode={true}
						hideCountry={true}
						className="materialCard__supportingText"
						address={nullSafeGet('primaryAddress', contractorLocation)}
					/>
				</div>
				{!isTextElementEmpty(contractorLocation.notes) ? (
					<div style={{ padding: 24, paddingTop: 0 }}>
						<Divider style={{ marginTop: 0 }} />
						<div
							className="richTextWrapper"
							dangerouslySetInnerHTML={{ __html: contractorLocation.notes }}
						/>
					</div>
				) : null}
			</Card>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(ContractorLocationCardDisplay);
